/* PG Homepage — Hero slideshow (carousel arrows handled by pg-carousel-arrows.js) */
document.addEventListener('DOMContentLoaded', function() {

  /* ═══ Hero slideshow — proper slide animation ═══ */
  var hero = document.querySelector('.pg-hero-carousel');
  if (!hero) return;

  var slides = hero.querySelectorAll('.pg-hero-slide');
  var dots = hero.querySelectorAll('.pg-hero-dot');
  if (slides.length < 2) return;

  var current = 0;
  var total = slides.length;
  var interval = (parseInt(hero.dataset.autoAdvance) || 5) * 1000;
  var timer = null;
  var animating = false;

  function goTo(index, direction) {
    if (animating) return;
    var next = ((index % total) + total) % total;
    if (next === current) return;
    animating = true;

    if (direction === undefined) direction = next > current ? 1 : -1;

    var oldSlide = slides[current];
    var newSlide = slides[next];

    // Position new slide off-screen (instant, no transition)
    newSlide.style.transition = 'none';
    newSlide.style.transform = direction === 1 ? 'translateX(100%)' : 'translateX(-100%)';

    // Force reflow
    void newSlide.offsetHeight;

    // Animate both slides
    newSlide.style.transition = '';
    newSlide.style.transform = 'translateX(0)';
    newSlide.classList.add('pg-hero-slide--active');

    oldSlide.style.transform = direction === 1 ? 'translateX(-100%)' : 'translateX(100%)';
    oldSlide.classList.remove('pg-hero-slide--active');

    // Update dots
    if (dots.length) {
      dots[current].classList.remove('pg-hero-dot--active');
      dots[next].classList.add('pg-hero-dot--active');
    }

    current = next;

    setTimeout(function() {
      animating = false;
    }, 520);
  }

  function startAuto() {
    stopAuto();
    timer = setInterval(function() { goTo(current + 1, 1); }, interval);
  }

  function stopAuto() {
    if (timer) { clearInterval(timer); timer = null; }
  }

  // ⚠ Null-checked. These used to be `hero.querySelector('.pg-hero-arrow--left')
  // .addEventListener(...)` with nothing between — and querySelector returns null, not
  // a stub. A hero configured with one slide, or a future markup change that drops the
  // arrows, threw here and took EVERYTHING BELOW with it: the dots, the touch-swipe
  // handlers and startAuto(). The rotator would then sit on slide one, silently, on
  // the shop's most important page. One missing optional control should not be able to
  // disable the component it decorates.
  var arrowLeft = hero.querySelector('.pg-hero-arrow--left');
  if (arrowLeft) {
    arrowLeft.addEventListener('click', function (e) {
      e.preventDefault();
      goTo(current - 1, -1);
      startAuto();
    });
  }

  var arrowRight = hero.querySelector('.pg-hero-arrow--right');
  if (arrowRight) {
    arrowRight.addEventListener('click', function (e) {
      e.preventDefault();
      goTo(current + 1, 1);
      startAuto();
    });
  }

  dots.forEach(function(dot) {
    dot.addEventListener('click', function() {
      var idx = parseInt(dot.dataset.index);
      goTo(idx, idx > current ? 1 : -1);
      startAuto();
    });
  });

  hero.addEventListener('mouseenter', stopAuto);
  hero.addEventListener('mouseleave', startAuto);

  var touchStartX = 0;
  hero.addEventListener('touchstart', function(e) {
    touchStartX = e.touches[0].clientX;
    stopAuto();
  }, { passive: true });

  hero.addEventListener('touchend', function(e) {
    var diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      goTo(diff > 0 ? current + 1 : current - 1, diff > 0 ? 1 : -1);
    }
    startAuto();
  }, { passive: true });

  startAuto();
});
